import { Component, OnInit, EventEmitter, Input, ViewChild } from '@angular/core';
import { BuscaCobros } from '../../entidades/entidades';
import { BuscaCobrosComponent } from '../../componentes/busca-cobros/busca-cobros.component';

@Component({
  selector: 'app-facturacion',
  templateUrl: './facturacion.component.html',
  styleUrls: ['./facturacion.component.css']
})
export class FacturacionComponent implements OnInit {

  public buscaCobros$ = new EventEmitter<BuscaCobros>();
  @ViewChild(BuscaCobrosComponent) buscaCobrosLimpiar: BuscaCobrosComponent;


  display: boolean = false;
  showDialog() {
    this.display = true;
  }
  mostrar = true;
  bandera = false;
  // busca = this.buscaCobros$;
  constructor() { }

  ngOnInit() {
  }
  async childBuscaCobros(buscaCobros: BuscaCobros) {
    try {
      // Carga Componente CMP-FACTURACIÓN
      let buscaCobro = new BuscaCobros();
      buscaCobro = buscaCobros;
      console.log('PASO 1', buscaCobros);
      //
      console.log(buscaCobros);

      await this.buscaCobros$.emit(buscaCobro);
      if(!buscaCobros)
        return;
      if (buscaCobros.condicion === '3') {
        this.bandera = true;
        this.display = true;
      } else {
        this.bandera = false;
        this.mostrar = false;
      }

    } catch (e) {
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por childBuscaCobros');
    }
  }
  
  async regresa() {
    this.mostrar = true;
    this.buscaCobros$.emit();
  }

  async regresaGrid() {
    this.mostrar = true;
    this.buscaCobros$.emit();
    this.buscaCobrosLimpiar.limpiar();
  }
}
